import {
  NanoCheckbox,
  NanoCheckboxGroup,
} from "@nanoporetech-digital/components-react";
import { Control, Controller } from "react-hook-form";
import useErrorRef from "../../common/input-utils/useErrorRef";
import { PublicRegistration } from "../../types/registration";

export interface InputConfirmBoxProps {
  control: Control<PublicRegistration, any>;
  name: keyof PublicRegistration;
  label: string;
  className?: string;
}

export default function InputConfirmBox({
  control,
  name,
  label,
  className,
}: InputConfirmBoxProps) {
  const errorRef = useErrorRef<HTMLNanoCheckboxGroupElement>(name);

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value, onBlur, ref } }) => (
        <NanoCheckboxGroup className={className} ref={errorRef}>
          <NanoCheckbox
            name={name}
            label={label}
            type="checkbox"
            checked={value === true}
            onNanoChange={(event) => onChange(event.target.checked)}
          />
        </NanoCheckboxGroup>
      )}
    />
  );
}
